import { render } from "./ViewFiles.vue?vue&type=template&id=b0e0d7fa&scoped=true"
import script from "./ViewFiles.vue?vue&type=script&lang=js"
export * from "./ViewFiles.vue?vue&type=script&lang=js"

import "./ViewFiles.vue?vue&type=style&index=0&id=b0e0d7fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e0d7fa"]])

export default __exports__